import React from "react";
import { useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";
import { User } from "../../types";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { AdapterLink } from "../../../../components/Adopter";
import { Routes } from "../../../../constants/routes";
import CircularProgress from "@material-ui/core/CircularProgress";
import StudentIcon from "../../../../assets/svg/student.svg";
import { useAuth } from "../../../auth/hooks/useAuth";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textAlign: "center",
  },
  progress: {
    position: "relative",
    width: 100,
    height: 100,
    display: "inline-flex",

    "& > .MuiCircularProgress-static": {
      position: "absolute",
      zIndex: 10,
      width: "100%!important",
      height: "100%!important",
      transform: "rotate(-90deg)!important",
      transformOrigin: "50% 50%",
      "& circle": {
        strokeWidth: 3,
        strokeLinecap: "round",
      },
    },
  },
  avatar: {
    position: "absolute",
    display: "inline-flex",
    height: 80,
    width: 80,
    left: 10,
    top: 10,
  },
}));

export default function StudentGridItem({ student }: { student: User }) {
  const { user } = useAuth();
  const classes = useStyles();

  const color = useMemo(() => {
    return student.studentProfile.filled < 70 ? "#f6b900" : "#7ec884";
  }, [student.studentProfile.filled]);

  return (
    <Grid item xs={6} sm={3} md={2} className={classes.root}>
      <AdapterLink
        to={
          user.role === 2
            ? `/0/${Routes.USER_STUDENTS}/${student.id}`
            : `/0/${Routes.USERS}/${student.id}/edit`
        }
      >
        <div className={classes.progress}>
          <CircularProgress
            style={{ color }}
            variant="static"
            value={student.studentProfile.filled}
          />
          <Avatar
            src={(student.photo && student.photo.preview) || StudentIcon}
            className={classes.avatar}
          />
        </div>
        <Typography>{student.name}</Typography>
      </AdapterLink>
    </Grid>
  );
}
